import React, {useState} from 'react';
import { Popover, ArrowContainer } from 'react-tiny-popover'
import {Card} from "react-bootstrap";
function Tooltip(props) {
    const [open,setOpen] = useState(false)
    return (
        <Popover
            isOpen={open}
            positions={['top', 'left']} // if you'd like, you can limit the positions
            padding={0} // adjust padding here!
            reposition={false} // prevents automatic readjustment of content position that keeps your popover content within its parent's bounds
            //onClickOutside={() => this.setPopoverOpen(false)} // handle click events outside of the popover/target here!
            content={({position, childRect, popoverRect}) => {
                return (
                    <ArrowContainer // if you'd like an arrow, you can import the ArrowContainer!
                        position={position}
                        childRect={childRect}
                        popoverRect={popoverRect}
                        arrowColor={"#eeeeee"}
                        arrowSize={10}
                        arrowStyle={{opacity: 1}}
                        className='popover-arrow-container'
                        arrowClassName='popover-arrow'
                    >

                        <Card className={'shadow-sm p-2 bg-mute font-alt border-0 bold'}>
                            {props.body}
                        </Card>

                    </ArrowContainer>
                )
            }}
        >
            <div onMouseEnter={()=>{setOpen(true)}} onMouseLeave={()=>{setOpen(false)}}>

                {props.children}

            </div>
        </Popover>
    )
}

export default Tooltip;